<h1 class="mat-h1" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  {{ data.title }}
</h1>
<div mat-dialog-content>
  <p>{{ data.question }}</p>
</div>
<div class="row" mat-dialog-actions>
  <button (click)="onCancel()" class="col btn-cancel" mat-raised-button color="warn">
    Cancelar
  </button>
  <button (click)="onOk()" class="col btn-submit" mat-raised-button color="primary">
    Confirmar
  </button>
</div>
